/* Riprende il prodotto visto in Hero 04, senza scaricare pagine del catalogo.
   L'indice originale serve solo a individuare la pagina: il bersaglio e' l'ID. */
(() => {
  const url = new URL(location.href);
  const productId = url.searchParams.get('extro_product');
  const position = Number(url.searchParams.get('extro_position'));
  if (!productId || !/^\d+$/.test(productId)) return;
  const grid = document.querySelector('[data-extro-collection]');
  if (!grid) return;
  const target = grid.querySelector(`[data-extro-product-id="${productId}"]`);
  const perPage = Number(grid.dataset.pageSize);
  const page = Number(url.searchParams.get('page')) || 1;
  if (!target && Number.isInteger(position) && position > 0 && position <= 50 && perPage > 0) {
    const destination = Math.ceil(position / perPage);
    if (destination !== page) {
      url.searchParams.set('page', destination);
      location.replace(url.href);
      return;
    }
  }
  url.searchParams.delete('extro_product');
  url.searchParams.delete('extro_position');
  history.replaceState(history.state, '', url.href);
  // Se il catalogo e' cambiato nel frattempo, resta accessibile la griglia normale.
  if (!target) return;
  const scroll = () => {
    target.style.scrollMarginTop = 'calc(var(--header-height, 80px) + 80px)';
    target.scrollIntoView({ block: 'start', behavior: 'instant' });
    target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
    target.addEventListener('blur', () => target.removeAttribute('tabindex'), { once: true });
  };
  (document.fonts ? document.fonts.ready : Promise.resolve()).then(() => requestAnimationFrame(scroll));
})();
